/* "You may also like" inside the cart drawer.
   Fetches Shopify's own recommendations for the first item in the cart and
   renders them through sections/sds-cart-recs.liquid. Re-runs itself whenever
   the drawer re-renders (adding or removing an item replaces its innerHTML). */
(function () {
  var LIMIT = 8;
  var STORAGE_KEY = 'sdsRecsOpen';
  var inFlight = null;

  function firstCartProductId(root) {
    var el = root.querySelector('[data-sds-recs]');
    return el ? el.getAttribute('data-product-id') : null;
  }

  /* Always start expanded. It used to remember a collapsed state per visitor
     in localStorage, which meant anyone who closed it once never saw the
     recommendations again. Collapsing still works, it just isn't persisted. */
  function isOpen() {
    return true;
  }

  function setOpen() {
    /* deliberately not persisted */
  }

  function paint(wrap, html) {
    var body = wrap.querySelector('.sds-recs__body');
    if (!body) return;
    body.innerHTML = html;
    var has = !!body.querySelector('.sds-recs__card');
    wrap.hidden = !has;
    if (has) applyOpenState(wrap, isOpen());
  }

  function applyOpenState(wrap, open) {
    wrap.classList.toggle('is-open', open);
    var head = wrap.querySelector('.sds-recs__head');
    if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function load(root) {
    var wrap = root.querySelector('[data-sds-recs]');
    if (!wrap || wrap.dataset.sdsLoaded === '1') return;
    var pid = firstCartProductId(root);
    if (!pid) return;
    wrap.dataset.sdsLoaded = '1';

    var url =
      window.Shopify.routes.root +
      'recommendations/products?section_id=sds-cart-recs&limit=' +
      LIMIT +
      '&product_id=' +
      pid;

    if (inFlight) inFlight.abort();
    var ctrl = new AbortController();
    inFlight = ctrl;
    fetch(url, { signal: ctrl.signal })
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var track = doc.querySelector('.sds-recs__track');
        paint(wrap, track ? track.outerHTML : '');
      })
      .catch(function () {
        /* network hiccup: leave the block hidden, the cart still works */
      });
  }

  /* Un div con role="button" no dispara click con el teclado como lo hace un
     <button> de verdad, asi que lo traducimos a mano. Solo para los que lo
     declaran: las tarjetas de recomendacion dejan el foco en su boton "+". */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var card = e.target.closest('[data-sds-add][role="button"]');
    if (!card) return;
    e.preventDefault();
    card.click();
  });

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.sds-recs__head');
    if (head) {
      var wrap = head.closest('[data-sds-recs]');
      var open = !wrap.classList.contains('is-open');
      applyOpenState(wrap, open);
      setOpen(open);
      return;
    }

    var add = e.target.closest('[data-sds-add]');
    if (!add) return;
    e.preventDefault();
    if (add.dataset.busy === '1') return;
    add.dataset.busy = '1';
    add.classList.add('is-busy');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(add.getAttribute('data-sds-add')), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.renderContents(data);
          /* renderContents de Dawn intenta quitar is-empty de .drawer__inner,
             pero la clase esta en <cart-drawer>: esa linea suya no hace nada.
             Si se queda puesta con el carrito ya lleno, la regla
             "cart-drawer.is-empty .drawer__inner { display:grid }" reparte las
             cuatro zonas del cajon en COLUMNAS y el contenido se sale por la
             derecha (medido: 1110px dentro de 398px), ademas de dejar la
             cabecera en display:none. Dawn lo compensa igual desde fuera en
             product-form.js:104; aqui hacemos lo mismo. Acabamos de anadir un
             articulo, asi que el carrito no puede estar vacio. */
          drawer.classList.remove('is-empty');
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        add.dataset.busy = '';
        add.classList.remove('is-busy');
      });
  });

  function boot() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    load(drawer);
    // the drawer swaps its own innerHTML on every cart change
    new MutationObserver(function () {
      load(drawer);
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
